export default __webpack_public_path__ + "static/media/Pizza.73e1b0f9.png";